/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/user/getUserInfo',
    queryPlayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    vote_status : '/api/race/getRacePlayerRate',
    vote_record : '/api/race/voteRecords',
    vote_player : '/api/race/voteUsers',
    vote_team : '/api/race/voteRaceTeams',
    news_list : '/api/edi/getTimeEvent',
}

export const apiUserinfo = p => post(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryPlayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiVoteStatus = p => get(user_api.vote_status, p);
export const apiVoteRecord = p => get(user_api.vote_record, p);
export const apiVotePlayer = p => post(user_api.vote_player, p);
export const apiVoteTeam = p => post(user_api.vote_team, p);
export const apiNewsList = p => get(user_api.news_list, p);